<!-- Send Bulk Email Modal -->
<p-dialog [visible]="showPopup()" (onHide)="closePopupUp()" [closeOnEscape]="false" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{ '991px': '100vw' }" [style]="{ width: '870px' }" styleClass="no-header-modal" aria-label="send-bulk-email-dialog" data-testid="send-bulk-email-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="p-3 sticky top-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
      @if (emailSendType()  === GetEmailSendType.Bulk) {
        <h2 class="mb-0 text-sm" data-testid="bulk-email-header">
          {{'SEND_EMAIL.SEND_BULK_EMAIL' | translate }}
        </h2>
      }
      @if (emailSendType() === GetEmailSendType.FreeForm) {
        <h2 class="mb-0 text-sm" data-testid="free-form-email-header" [innerHTML]="'SEND_EMAIL.SEND_FREE_FORM_EMAIL' | translate : { name: this.SelectedClient().value.full_name }"></h2>
      }
      @if (emailSendType() === GetEmailSendType.Campaign) {
        <h2 class="mb-0 text-sm" data-testid="campaign-email-header">
          {{'SEND_EMAIL.EMAIL_CONFIG' | translate }}
        </h2>
      }
      @if (emailSendType() === GetEmailSendType.Automation) {
        <h2 class="mb-0 text-sm" data-testid="automation-email-header">
          {{'SEND_EMAIL.EMAIL_CONFIG' | translate }}
        </h2>
      }
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopupUp()" aria-label="close-email-dialog" data-testid="close-email-dialog"></div>
    </div>
    <!-- Header -->

    @if (emailSendType() === GetEmailSendType.FreeForm) {
      <div>
        <p-message severity="warn" icon="fa fa-exclamation-triangle" aria-label="email-warning-message">
          {{'SEND_EMAIL.INFO_1' | translate }}
        </p-message>
      </div>
    }

    <form [formGroup]="sendEmailForm">
      <!-- Show skeleton when loading -->
      @if (loading) {
        <div class="p-3 surface-100" data-testid="email-form-skeleton">
          <!-- Automation Schedule Type Skeleton -->
          <div class="mb-3">
            <p-skeleton width="100%" height="120px" />
          </div>
          <div class="surface-0 shadow-3 border-round relative text-sm">
            <!-- Campaign Toggle Skeleton -->
            <div class="flex align-items-center mb-2">
              <p-skeleton width="120px" height="24px" styleClass="mr-2" />
              <p-skeleton width="40px" height="24px" />
            </div>
            <div class="surface-0 shadow-3 border-round relative text-sm">
              <!-- Email Content Section -->
              <div class="surface-0 shadow-3 border-round relative text-sm">
                <div class="px-3 pt-3 pb-1">
                  <!-- From Dropdown -->
                  <div class="pl-6 relative mb-2">
                    <p-skeleton width="40px" height="16px" styleClass="absolute left-0 top-0 mt-2" />
                    <p-skeleton width="100%" height="35px" />
                  </div>
                  <!-- To Section -->
                  <div class="pl-6 relative mb-2">
                    <p-skeleton width="30px" height="16px" styleClass="absolute left-0 top-0 mt-2" />
                    <div class="flex flex-wrap align-items-center -ml-2">
                      <p-skeleton width="200px" height="35px" styleClass="m-2" />
                      <p-skeleton width="200px" height="35px" styleClass="m-2" />
                      <p-skeleton width="200px" height="35px" styleClass="m-2" />
                      <p-skeleton width="150px" height="24px" styleClass="ml-3 mt-2" />
                    </div>
                  </div>
                  <!-- Subject -->
                  <div class="pl-6 relative mb-2 border-top-1 border-bottom-1 border-300 py-2">
                    <p-skeleton width="60px" height="16px" styleClass="absolute left-0 top-0 mt-3" />
                    <p-skeleton width="100%" height="35px" styleClass="ml-2" />
                  </div>
                  <!-- Editor -->
                  <div class="w-full relative">
                    <p-skeleton width="100%" height="160px" />
                  </div>
                </div>
                <!-- Template Dropdown -->
                <div class="surface-200 mt-2 text-center md:text-left py-1 md:px-3 px-0 md:flex align-items-center">
                  <p-skeleton width="200px" height="35px" />
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Footer Skeleton -->
      @if (loading) {
        <div class="p-3 sticky bottom-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-top-1 border-300">
          <p-skeleton width="100px" height="35px" />
          <p-skeleton width="120px" height="35px" />
        </div>
      }

      <!-- Show actual content when not loading -->
      @if (!loading) {
        <div>
          @if (emailSendType() === GetEmailSendType.Automation && showScheduleType.value) {
            <automation-schedule-type [formGroup]="sendEmailForm" [automationMaster]="automationMaster()" [type]="'EMAIL'" aria-label="automation-schedule-type" data-testid="automation-schedule-type" />
          }
          <div class="p-3 surface-100">
            <!-- Content -->
            <!-- <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"> -->
            @if (showCampaign.value && emailSendType() === GetEmailSendType.Bulk) {
              <div class="flex align-items-center mb-2">
                <strong class="text-sm mb-0 mr-2 -mt-1 cursor-pointer" data-testid="campaign-toggle-label">
                  {{'SEND_EMAIL.IS_CAMPAIGNS' | translate }}
                </strong>
                <p-toggleSwitch formControlName="is_visible" aria-label="campaign-visibility-toggle" data-testid="campaign-visibility-toggle" />
              </div>
            }
            <div class="surface-0 shadow-3 border-round relative text-sm">
              <!-- Campaign Fields Section -->
              @if (IsVisibleFormControl.value && emailSendType() === GetEmailSendType.Bulk) {
                <div class="p-3">
                  <!-- Form Group -->
                  <div class="mb-3">
                    <label for="campaign-name-input" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-name-label">
                      {{'SEND_EMAIL.CAMPAIGN_NAME' | translate }}
                    </label>
                    <input type="text" formControlName="campaign_name" class="text-sm w-full" pInputText [placeholder]="'SEND_EMAIL.NAME_PLACEHOLDER' | translate"
                      [ngClass]="{ 'ng-invalid ng-dirty': CampaignNameFormControl.invalid && CampaignNameFormControl.touched }" aria-label="campaign-name-input" data-testid="campaign-name-input" />
                    @if (CampaignNameFormControl.touched && CampaignNameFormControl.invalid) {
                      <app-error-msg [errors]="CampaignNameFormControl.errors" [fieldLabel]="'SEND_EMAIL.CAMPAIGN_NAME_ERROR' | translate" data-testid="campaign-name-error" />
                    }
                  </div>
                  <!-- Form Group -->
                  
                  <!-- Form Group -->
                  <div class="mb-3">
                    <label for="campaign-description-input" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="campaign-description-label">
                      {{'SEND_EMAIL.CAMPAIGN_DESCRIPTION' | translate }}
                    </label>
                    <textarea pInputTextarea formControlName="campaign_description" class="text-sm w-full h-4rem" [placeholder]="'SEND_EMAIL.DESC_PLACEHOLDER' | translate"
                      [ngClass]="{ 'ng-invalid ng-dirty': CampaignDescriptionFormControl.invalid && CampaignDescriptionFormControl.touched }" aria-label="campaign-description-input" data-testid="campaign-description-input"></textarea>
                    @if (CampaignDescriptionFormControl.touched && CampaignDescriptionFormControl.invalid) {
                      <app-error-msg [errors]="CampaignDescriptionFormControl.errors"
                        [fieldLabel]="'SEND_EMAIL.CAMPAIGN_DESCRIPTION_ERROR' | translate"
                        data-testid="campaign-description-error" />
                    }
                  </div>
                  <!-- Form Group -->
                  
                  <!-- Form Group -->
                  <div class="mb-0">
                    <label for="campaign-schedule-date-input" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="schedule-date-label">
                      {{'SEND_EMAIL.SCHEDULE_DATE_ERROR' | translate }}
                    </label>
                    <p-datepicker [showIcon]="true"
                      formControlName="campaign_action_date"
                      icon="fa fa-calendar font-light"
                      dateFormat="M dd,yy"
                      [yearNavigator]="true"
                      yearRange="2023:2030"
                      appendTo="body"
                      [placeholder]="'SEND_EMAIL.CHOOSE_DATE' | translate"
                      inputStyleClass="text-sm"
                      [ngClass]="{ 'ng-invalid ng-dirty': CampaignActionDateFormControl.invalid && CampaignActionDateFormControl.touched }"
                      aria-label="schedule-date-input"
                      data-testid="schedule-date-input" />
                    @if (CampaignActionDateFormControl.touched && CampaignActionDateFormControl.invalid) {
                      <app-error-msg [errors]="CampaignActionDateFormControl.errors" [fieldLabel]="'SEND_EMAIL.SCHEDULE_DATE' | translate" data-testid="schedule-date-error" />
                    }
                  </div>
                  <!-- Form Group -->
                </div>
              }
              
              <!-- Content Label -->
              @if (showCampaign.value && emailSendType() === GetEmailSendType.Bulk) {
                <div class="px-3 pt-3 pb-2">
                  <label for="content-input" class="font-medium text-700 text-xs mb-0 block uppercase" data-testid="content-label">
                    {{'SEND_EMAIL.CONTENT' | translate }}
                  </label>
                </div>
              }
              
              <!-- Content Section -->
              <div class="surface-0 shadow-3 border-round relative text-sm">
                  <div class="px-3 pt-3 pb-1">
                    <!-- From -->
                    <div class="pl-6 relative mb-2">
                      <span class="absolute left-0 top-0 mt-2" data-testid="from-email-label">
                        {{'SEND_EMAIL.FROM' | translate }}
                      </span>
                      <p-select [options]="emailFrom" formControlName="email_from" optionLabel="from_email" appendTo="body" filterBy="from_email" styleClass="text-sm text-black-alpha-90 w-full"
                        [ngClass]="{ 'ng-invalid ng-dirty': SelectedEmailFromFormControl.invalid && SelectedEmailFromFormControl.touched }" aria-label="from-email-dropdown" data-testid="from-email-dropdown">
                        <ng-template pTemplate="selectedItem">
                          @if (SelectedEmailFromFormControl.value) {
                            <strong class="text-sm">{{ SelectedEmailFromFormControl.value.from_email }}</strong>
                          }
                        </ng-template>
                        <ng-template let-emailFrom pTemplate="item">
                          <div class="text-sm">{{ emailFrom.from_email }} {{emailFrom.isCorporate ? '(Corporate)' : ''}}</div>
                        </ng-template>
                      </p-select>
                    </div>
                    <!-- From -->
                    <!-- To -->
                    @if (emailSendType() !== GetEmailSendType.Campaign && emailSendType() !== GetEmailSendType.Automation) {
                      <div class="pl-6 relative mb-2">
                        <span class="absolute left-0 top-0 mt-2" data-testid="to-email-label">
                          {{'SEND_EMAIL.TO' | translate }}
                        </span>
                        <div class="flex flex-wrap align-items-center -ml-2" data-testid="recipient-list">
                          @for (email of getClientEmailsIds() | slice:0:3; track email) {
                            <strong class="bg-primary border-round p-2 m-2 text-center w-full md:w-auto block">
                              {{email}}
                            </strong>
                          }
                          @if (emailSendType() === GetEmailSendType.Bulk) {
                            <div
                              class="text-primary ml-3 mt-2 font-bold"
                              data-testid="total-recipients"
                              [innerHTML]="'SEND_EMAIL.TOTAL_RECORDS' | translate : { count : selectedAllData().value ? totalRecords().value : getClientEmailsIds().length }">
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <!-- To -->
                    <!-- Subject -->
                    <div class="pl-6 relative mb-2 border-top-1 border-bottom-1 border-300 py-2">
                      <span class="absolute left-0 top-0 mt-3" data-testid="subject-label">
                        {{'SEND_EMAIL.SUBJECT' | translate }}
                      </span>
                      <input type="text" formControlName="subject" pInputText [placeholder]="'SEND_EMAIL.SUBJECT_PLACEHOLDER' | translate" class="p-inputtext-sm w-full border-none ml-2"
                        [ngClass]="{ 'ng-invalid ng-dirty': SubjectFormControl.invalid && SubjectFormControl.touched }" aria-label="email-subject-input" data-testid="email-subject-input"/>
                        @if (SubjectFormControl.touched && SubjectFormControl.invalid) {
                          <app-error-msg [errors]="SubjectFormControl.errors" [fieldLabel]="'SEND_EMAIL.SUBJECT' | translate" data-testid="subject-error" />
                        }
                      </div>
                      <!-- Subject -->
                      <!-- Message -->
                      <div class="w-full relative">
                        <p-editor [style]="{ height: '160px' }" formControlName="body" [readonly]="bodyreadOnly" (ngModelChange)="Updatevalue($event)"
                        [ngClass]="{ 'ng-invalid ng-dirty': BodyFormControl.invalid && BodyFormControl.touched }" #editor aria-label="email-body-editor" data-testid="email-body-editor" />
                        @if (BodyFormControl.touched && BodyFormControl.invalid) {
                          <app-error-msg [errors]="BodyFormControl.errors" [fieldLabel]="'SEND_EMAIL.CONTENT_LABEL' | translate" data-testid="body-error" />
                        }
                      </div>
                      <!-- Message -->
                    </div>
                    <!-- Options -->
                    <div class="surface-200 mt-2 text-center md:text-left py-1 md:px-3 px-0 md:flex align-items-center">
                      <p-select
                        [options]="emailTemplateMasters$.value"
                        formControlName="email_template"
                        dropdownIcon="fa fa-chevron-down"
                        optionLabel="name_primary_language"
                        filterBy="name_primary_language"
                        appendTo="body"
                        styleClass="border-none surface-200 text-primary text-sm font-bold ml-2"
                        [placeholder]="'SEND_EMAIL.CHOOSE_TEMPLATE' | translate"
                        [emptyMessage]="emailSendType() === GetEmailSendType.Automation ? ('SEND_EMAIL.NO_TEPLATE_FOR_EVENT' | translate : { event_type: automationMaster().value.friendly_name }) : ('SEND_EMAIL.NO_TEMPLATE_FOUND' | translate)"
                        (onChange)="SelectEmailTemplate()"
                        aria-label="email-template-dropdown"
                        data-testid="email-template-dropdown">
                        <ng-template pTemplate="selectedItem">
                          @if (SelectedEmailTemplateFormControl.value) {
                            <strong class="text-sm text-primary">{{ SelectedEmailTemplateFormControl.value.name_primary_language }}</strong>
                          }
                        </ng-template>
                        <ng-template let-template pTemplate="item">
                          <div class="text-sm">{{ template.name_primary_language }}</div>
                        </ng-template>
                      </p-select>
                    </div>
                    <!-- Options -->
                    <!-- <div class="flex align-items-center p-3" *ngIf="emailSendType == GetEmailSendType.FreeForm">
                    <p-toggleSwitch></p-toggleSwitch>
                    <label class="ml-3 -mt-1 flex align-items-center">
                      {{'SEND_EMAIL.NOT_MARKETING_MSG' | translate }} <i class="fa fa-circle-question text-base text-600 cursor-pointer ml-2" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i>
                    </label>
                  </div> -->
                </div>
                <!-- Form Group -->
              </div>
            </div>
            <!-- Content -->
            <!-- Modal Footer -->
            <div class="p-3 sticky bottom-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-top-1 border-300">
              <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-link text-sm" (click)="closePopupUp()" aria-label="cancel-bulk-email-button" data-testid="cancel-bulk-email-button" />
              @if (emailSendType() !== GetEmailSendType.Campaign && emailSendType() !== GetEmailSendType.Automation) {
                <p-button [label]="'SEND_EMAIL.SEND_EMAIL' | translate" [disabled]="!isFormValid" [loading]="btnLoading" styleClass="text-sm" (click)="SendEmail()" aria-label="send-bulk-email-button" data-testid="send-bulk-email-button" />
              }
              @if (emailSendType() === GetEmailSendType.Campaign || emailSendType() === GetEmailSendType.Automation) {
                <p-button [label]="'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate" [disabled]="!isFormValid" [loading]="btnLoading" styleClass="text-sm" (click)="SaveData()" aria-label="submit-bulk-email-button" data-testid="submit-bulk-email-button" />
              }
            </div>
            <!-- Modal Footer -->
          </div>
        }
      </form>
    </ng-template>
  </p-dialog>
  <!-- Send Bulk Email Modal -->
